module.exports = __webpack_public_path__ + "static/media/megali-paraskeui-book.cc119f30.jpg";